// Serialize nested params to Strapi query format (e.g., filters[Title][$containsi]=value)
const serializeStrapiParams = (params, prefix = '') => {
  const pairs = [];

  for (const key in params) {
    if (!Object.prototype.hasOwnProperty.call(params, key)) continue;

    const value = params[key];
    const newKey = prefix ? `${prefix}[${key}]` : key;

    if (value === null || value === undefined) {
      continue;
    }

    if (typeof value === 'object' && !Array.isArray(value) && !(value instanceof Date)) {
      // Recursively serialize nested objects
      pairs.push(...serializeStrapiParams(value, newKey));
      continue;
    }

    // Encode arrays and primitives
    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        const indexedKey = `${newKey}[${index}]`;
        // Recurse for array of objects (e.g. $and, $or) so nested filters serialize correctly
        if (typeof item === 'object' && item !== null && !(item instanceof Date)) {
          pairs.push(...serializeStrapiParams(item, indexedKey));
        } else {
          // For Strapi, arrays in filters (e.g. $in) need indexed format
          pairs.push(`${indexedKey}=${encodeURIComponent(item)}`);
        }
      });
    } else {
      pairs.push(`${newKey}=${encodeURIComponent(value)}`);
    }
  }

  return pairs;
};

export default serializeStrapiParams;
